/**
 * The partnership code a visitor arrived with, kept across signing in, signing up and founding an
 * organisation: the sign-up and founding screens leave the `/connect/:code` URL, so without the
 * stash a company new to the system would lose the code on its way to an organisation.
 *
 * `sessionStorage` scopes it to the tab and forgets it with the tab. Every access is wrapped,
 * because storage throws in a private window or with site data blocked, and a lost code only
 * means the visitor opens the link again.
 */
const CONNECT_CODE_KEY = "msuite.connect-code";

/**
 * Remember the code from a connect link until it is redeemed or taken.
 *
 * @param code - The partnership code from the URL.
 */
export function rememberConnectCode(code: string) {
	try {
		sessionStorage.setItem(CONNECT_CODE_KEY, code);
	} catch {
		// Storage unavailable: the code lives only in the URL.
	}
}

/**
 * Read the remembered code and clear it, so it leads to the connect page once.
 *
 * @returns The remembered code, or null when there is none or storage is unavailable.
 */
export function takeConnectCode() {
	try {
		const code = sessionStorage.getItem(CONNECT_CODE_KEY);
		sessionStorage.removeItem(CONNECT_CODE_KEY);
		return code;
	} catch {
		return null;
	}
}
